<template>
  <div>
    <game>
      <lottery-list slot="lottery"></lottery-list>
      <exclusive-list slot="exclusive"></exclusive-list>
      <show-coupon
        slot="showCoupon"
        :couponList="normalCouponList"
        :couponMetal="normalCouponMetal"
        @getCouponList="getNormalCouponList"
        @clickCoupon="clickCoupon"
      >
        <hot-brand-list
          slot="hotBrand"
          :brand="brandSelected"
          :hotBrandList="intentionBrandList"
          :isMore="isMore"
          @selectItem="clickBrand"
          @clickMore="changeShowMoreBrand"
        ></hot-brand-list>
      </show-coupon>
    </game>
    <index-bar
      :hot="true"
      :showDataPopup="showMoreBrand"
      :dataList="moreBrandList"
      @selectItem="clickBrand"
      @close="changeShowMoreBrand"
    >
    </index-bar>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Game from '@this/components/List/Game';
import lotteryList from '@this/connect/List/Lottery';
import exclusiveList from '@this/connect/List/Exclusive';
import ShowCoupon from '@this/components/List/ShowCoupon';
import HotBrandList from '@this/components/List/HotBrandList';
import IndexBar from '@this/components/List/IndexBar';
export default {
  created() {
    this.getTaskList();
    this.getCoupons();
    this.getCards();
  },
  watch: {
    brandSelected() {
      this.getNormalCouponList({ page: 1 });
    },
    city() {
      this.getNormalCouponList({ page: 1 });
    },
    uid: {
      handler() {
        this.getNormalCouponList({ page: 1 });
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('city', ['city']),
    ...mapState('brand', ['hotBrandList', 'brandSelected', 'showMoreBrand', 'intentionBrandList', 'showMoreBrand']),
    ...mapGetters('brand', ['isMore']),
    ...mapState('coupon', ['normalCouponList', 'normalCouponMetal', 'couponList']),
    moreBrandList() {
      return this.$store.state.brand.brandList;
    },
  },
  methods: {
    ...mapActions('config', ['getCards']),
    ...mapActions('task', ['getTaskList']),
    ...mapActions('coupon', ['clickCoupon', 'getNormalCouponList', 'getCoupons']),
    ...mapActions('brand', ['clickBrand', 'changeShowMoreBrand']),
  },
  components: {
    Game,
    lotteryList,
    exclusiveList,
    ShowCoupon,
    HotBrandList,
    IndexBar,
  },
};
</script>
<style lang="scss" scoped></style>
